import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthGuard, PrepareGuard } from 'app/core/core.module';
import { PartsOverviewComponent } from './parts-overview/parts-overview.component';
import { ModelsOverviewComponent } from './models-overview/models-overview.component';
import { PartsOrderOverviewComponent } from './parts-order-overview/parts-order-overview.component';
import { PartsByDateOverviewComponent } from './parts-date-overview/parts-date-overview.component';

import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { ProcessQueueOverviewComponent } from './process-queue-overview/process-queue-overview.component';
import { InventoryQueueOverviewComponent } from './inventory-queue-overview/inventory-queue-overview.component';
import { InventoryByDateComponent } from './inventory-by-date/inventory-by-date.component';
import { PartInStockOverviewComponent } from './part-instock-overview/part-instock-overview.component';
import { TimingOverviewComponent } from './timing-overview/timing-overview.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'overviews',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'search', pathMatch: 'full' },
                    { path: 'part-overview', component: PartsOverviewComponent, data: { title: 'Parts Overview' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'model-overview', component: ModelsOverviewComponent, data: { title: 'Model Overview' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'parts-order-overview', component: PartsOrderOverviewComponent, data: { title: 'Parts Per Order Overview' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'partsbydate', component: PartsByDateOverviewComponent, data: { title: 'Parts By Date Overview' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'process-queue-overview', component: ProcessQueueOverviewComponent, data: { title: 'Process Queue Overview' }, canActivate: [AuthGuard, PrepareGuard] },
                    {
                        path: 'inventory-queue-overview',
                        component: InventoryQueueOverviewComponent,
                        data: { title: 'Inventory Queue Overview' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'inventory-date',
                        component: InventoryByDateComponent,
                        data: { title: 'Inventory By Date Overview' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'part-instock',
                        component: PartInStockOverviewComponent,
                        data: { title: 'Part InStock Overview' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'timing',
                        component: TimingOverviewComponent,
                        data: { title: 'Timing Overview' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                ],
            },
        ]),
    ],
    declarations: [
        PartsOverviewComponent,
        ModelsOverviewComponent,
        PartsOrderOverviewComponent,
        PartsByDateOverviewComponent,
        ProcessQueueOverviewComponent,
        InventoryQueueOverviewComponent,
        InventoryByDateComponent,
        PartInStockOverviewComponent,
        TimingOverviewComponent,
    ],
})
export class OverviewsModule {}
